export default "__VITE_PUBLIC_ASSET__666e166d__"